import { render, staticRenderFns } from "./e-status-badge.vue?vue&type=template&id=3d9dcac6&scoped=true"
import script from "./e-status-badge.vue?vue&type=script&lang=js"
export * from "./e-status-badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9dcac6",
  null
  
)

export default component.exports